import { Category } from '@firmable/contracts';
import { ObjectHelper } from '@firmable/utilities';

export const AllowQuickLookUp = `AllowQuickLookUp`;
export const ManualSelection = `manualSelection`;

export const MaxDownloadLimit: Record<Category, number> = {
  company: 100, // as max 100 batch command is allowed in dynamo
  people: 100, // as max 100 batch command is allowed in dynamo
};

const FblUTM = {
  fbl_utm_source: 'utm_source',
  fbl_source: 'source',
  fbl_utm_medium: 'utm_medium',
  fbl_utm_campaign: 'utm_campaign',
  fbl_utm_content: 'utm_content',
  fbl_utm_term: 'utm_term',
  fbl_gclid: 'gclid',
  fbl_referer: 'referer',
};

const CreateTicketLink = 'https://help.firmable.com/kb-tickets/new';
const TermsOfUseLink = 'https://firmable.com/terms-of-use';

const DocsBaseLink = 'https://docs.firmable.com';
const McpDocsLink = `${DocsBaseLink}/mcp/overview`;

const VerticalPrefix = 'vert-';
const EnrichPrefix = 'enrich-';
const Firmable = 'fbl';

const CountryNamesByCode: Record<AvailableCountries, string> = {
  AU: 'Australia',
  NZ: 'New Zealand',
  HK: 'Hong Kong',
  JP: 'Japan',
  MY: 'Malaysia',
  PH: 'Philippines',
  SG: 'Singapore',
  ID: 'Indonesia',
  US: 'United States',
  CA: 'Canada',
  TH: 'Thailand',
  VN: 'Vietnam',
  KR: 'South Korea',
};

const CountryKeys: AvailableCountries[] = ObjectHelper.getKeys(CountryNamesByCode) as AvailableCountries[];

const DefaultCountryKey: AvailableCountries = 'AU';

export const App = {
  AllowQuickLookUp,
  MaxDownloadLimit,
  ManualSelection,
  FblUTM,
  VerticalPrefix,
  Firmable,
  EnrichPrefix,
  CreateTicketLink,
  TermsOfUseLink,
  DocsBaseLink,
  McpDocsLink,
  CountryNamesByCode,
  CountryKeys,
  DefaultCountryKey,
};
